const getters = {
    loading: (state) => state.loading,
    appointments: (state) => state.appointments,
    currentIndex: (state) => state.currentIndex,
    currentStep: (state) => state.currentStep,

    // Step 1
    issueId: (state) => state.issueId,
    mainProblem: (state) => state.mainProblem,
    selectedCategory: (state) => state.appointments[state.currentIndex].selectedCategory,
    serviceKeyword: (state) => state.appointments[state.currentIndex].serviceKeyword,
    selectedServiceState: (state) => state.appointments[state.currentIndex].selectedServiceState,
    selectedServiceCities: (state) => state.appointments[state.currentIndex].selectedServiceCities,
    serviceCategories: (state) => state.serviceCategories,
    citiesByCategory: (state) => state.citiesByCategory,
    publicServices: (state) => state.publicServices,

    // Step 2
    citiesByService: (state) => state.citiesByService,
    selectedPublicServiceDescription: (state) => state.appointments[state.currentIndex].publicService,
    locationKeyword: (state) => state.appointments[state.currentIndex].locationKeyword,
    selectedLocationState: (state) => state.appointments[state.currentIndex].selectedLocationState,
    selectedLocationCities: (state) => state.appointments[state.currentIndex].selectedLocationCities,
    availableDates: (state) => state.appointments[state.currentIndex].availableDates,
    bookingDate: (state) => state.appointments[state.currentIndex].bookingDate,
    selectedTimeSlotIndex: (state) => state.appointments[state.currentIndex].selectedTimeSlotIndex,
    selectedTime: (state) => state.appointments[state.currentIndex].selectedTime,
    locations: (state) => state.locations,
    selectedLocation: (state) => state.appointments[state.currentIndex].location,
    employees: (state) => state.employees,
    selectedEmployee: (state) => state.appointments[state.currentIndex].employee,
    employeeSchedule: (state) => state.employeeSchedule,
    bookedTimes: (state) => state.bookedTimes,
    selectedSchedule: (state) => state.appointments[state.currentIndex].schedule,

    //Step 3
    customerType: (state) => state.appointments[state.currentIndex].customerType,
    customerChildren: (state) => state.customerChildren,
    customerPets: (state) => state.customerPets,
    selectedCustomerId: (state) => state.appointments[state.currentIndex].customer.id,
    selectedChildId: (state) => state.appointments[state.currentIndex].customer.childId,
    selectedPetId: (state) => state.appointments[state.currentIndex].customer.petId,
}
export default getters
